// Slot grid constants shared between landing signup and admin portal
export const DAYS = [
  { key: "mon", label: "Mon" },
  { key: "tue", label: "Tue" },
  { key: "wed", label: "Wed" },
  { key: "thu", label: "Thu" },
  { key: "fri", label: "Fri" },
];

export const BLOCKS = [
  { key: "early-am", label: "Early AM", hint: "7–9 a.m." },
  { key: "late-am", label: "Late AM", hint: "10 a.m.–12 p.m." },
  { key: "early-pm", label: "Early PM", hint: "1–3 p.m." },
  { key: "late-pm", label: "Late PM", hint: "3:30–5:30 p.m." },
];

export const ALL_SLOT_KEYS = DAYS.flatMap((d) => BLOCKS.map((b) => `${d.key}-${b.key}`));

export function slotLabel(key) {
  const [d, ...rest] = key.split("-");
  const day = DAYS.find((x) => x.key === d)?.label || d;
  const blockKey = rest.join("-");
  const block = BLOCKS.find((x) => x.key === blockKey)?.label || blockKey;
  return `${day} · ${block}`;
}
